/**
 * @generated SignedSource<<b7db86a786c69e79831ed320f6d16d9f>>
 * @relayHash 78a4fa6b689d4cbc7ddaeff7fbad8d72
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b8a0d7c30b7cdf19e60700a7bb4501b482d5f7f7c30c325698e4eb0d78f0af43

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b8a0d7c30b7cdf19e60700a7bb4501b482d5f7f7c30c325698e4eb0d78f0af43",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
